import type React from 'react';

import { useSharingTools } from '../../hooks/useSharingTools/variant2';

import { RecommendedGroupsCardPreviewVariant2 } from './components/RecommendedGroupsCardPreview/variant2';

export const RecommendedGroupsCard: React.FC = () => {
	const { data, actions } = useSharingTools();

	return (
		<RecommendedGroupsCardPreviewVariant2
			recommendedGroups={data.recommendedGroups}
			primaryAction={actions.navigateToGroupRecommendations}
			fallbackPrimaryAction={actions.navigateToEditPetition}
			onFacebookGroupClick={actions.openRecommendedFacebookGroupModal}
			onRedditGroupClick={actions.openRecommendedRedditGroupModal}
		/>
	);
};
